import { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";

import MainPage from "../page/mainPage/mainPage";
import SignUp from "../page/signUp/SignUp";
import SignIn from "../page/signIn/SignIn";
import Settings from "../page/account/Settings";
import MngUser from "../page/mngUser/MngUser";
import MngVideo from "../page/mngVideo/MngVideo";
import VideoDetail from "../page/mngVideo/VideoDetail";
import MngShort from "../page/mngShort/MngShort";
import ShortDetail from "../page/mngShort/ShortDetail";
import Test from "../page/test/Test";

import { userState } from "../interface/MainInterface";
import * as AuthMain from "../auth/AuthMain";
import Toast from "../utils/Toast";
import MngVideoList from "../page/mngVideoList/MngVideoList";
import MainDashboard from "../page/dashboard/MainDashboard";
import MngStatistics from "../page/mngStatistics/MngStatistics";
import StatisticsDetail from "../page/mngStatistics/StatisticsDetail";

interface propsType {
  userState: userState;
  drawerWidth: number;
  setSelectedMenu: any;
  winSize: string;
  getLeftCount: any;
  searchResult: any;
  setSearchResult: any;
  openUploadVideo: any;
}

const MainConteiner = (props: propsType) => {
  const location = useLocation();
  const toastRef: any = useRef();

  useEffect(() => {
    const sessionCheck = async () => {
      try {
        if (!(await AuthMain.checkAuthenticated())) {
          moveHome();
        } else {
          props.setSelectedMenu(`/${location.pathname.split("/")[1]}`);
        }
      } catch (error) {
        moveHome();
      }
    };

    const moveHome = () => {
      toastRef.current?.toast("세션이 종료되었습니다.\n로그인 화면으로 이동합니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      setTimeout(() => {
        window.location.href = "/signin";
      }, 3000);
    };

    const pathName = `/${location.pathname.split("/")[1]}`;
    if (pathName === "/" || pathName === "/signin" || pathName === "/signup") {
      props.setSelectedMenu(pathName);
    } else {
      sessionCheck();
    }
    document.title = "Video Share Poc";
  }, [location, props]);

  return (
    <Box sx={{ ml: `${props.drawerWidth}px`, transition: "margin 0.5s", height: "calc(100vh - 44px)" }}>
      <Routes>
        <Route path="/" element={<MainPage userState={props.userState} />} />
        {/* <Route path="/signup" element={<SignUp userState={props.userState} />} /> */}
        <Route path="/main" element={<MainDashboard userState={props.userState} />} />
        <Route path="/signin" element={<SignIn userState={props.userState} />} />
        <Route path="/setting" element={<Settings userState={props.userState} />} />
        <Route path="/mngVideo" element={<MngVideo userState={props.userState} openUploadVideo={props.openUploadVideo} />} />
        <Route path="/detail/:videoSeq" element={<VideoDetail userState={props.userState} />} />
        <Route path="/statisticsDetail/:selectedDate" element={<StatisticsDetail userState={props.userState} />} />
        <Route path="/mngShort" element={<MngShort userState={props.userState} />} />
        <Route path="/mngVideoList" element={<MngVideoList userState={props.userState} />} />
        <Route path="/mngStatistics" element={<MngStatistics userState={props.userState} />} />
        <Route path="/shortDetail/:shortSeq" element={<ShortDetail userState={props.userState} />} />
        {props.userState.isAdmin && (
          <>
            <Route path="/mngUser" element={<MngUser userState={props.userState} />} />
          </>
        )}
        <Route path="/test" element={<Test userState={props.userState} />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
      <Toast ref={toastRef} />
    </Box>
  );
};

export default MainConteiner;
